module.exports = __webpack_public_path__ + "img/partner-bg.83dd3126.jpg";